import { MobileBridge } from "@wwg/mobile-bridge";

const mobileBridge = new MobileBridge({
  verbose: true,
});

function hasNativeMessageHandler() {
  if (typeof window === "undefined") {
    return false;
  }

  return Boolean(
    (window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.wwg) ||
      window.wwg
  );
}

const originalIsApp = mobileBridge.isApp.bind(mobileBridge);

// Prevent stale `wwg-mobile` cookies from disabling web navigation.
mobileBridge.isApp = () => originalIsApp() && hasNativeMessageHandler();

export default mobileBridge;
